import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlogAuthor } from 'src/app/blog-author.model';
import { BlogService } from 'src/app/blog.service';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-contributor-list-page',
	templateUrl: './contributor-list-page.component.html',
	styleUrls: ['./contributor-list-page.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ContributorListPageComponent implements OnInit {
	authorsLoading = true;
	authorsError = false;
	authors: Array<BlogAuthor> = [];
	trustedDesc: SafeHtml;
	trustedCopy: SafeHtml;
	title = "";
	icon = "";

	environment = environment;

	constructor(
		private metaSetter: MetaSetterService,
		private blogService: BlogService,
		private sanitiser: DomSanitizer,
	) {}

	ngOnInit(): void {
		this.blogService.getAppSettings("author-list")
			.subscribe(settings => {
				this.title = settings.page_title || settings.app_page_header;
				this.icon = settings.icon_thumbnail?.url || "";
				this.metaSetter.setMeta({
					title: settings.app_title,
					seoTitle: settings.seo_title,
					description: settings.seo_description || settings.app_description,
					metaImageURL: environment.defaultMetaImage,
					canonicalURL: environment.canonicalDomain + "/news/authors",
				});

				this.trustedDesc = this.sanitiser.bypassSecurityTrustHtml(settings.app_page_subheader);
				this.trustedCopy = this.sanitiser.bypassSecurityTrustHtml(settings.subheading_description);
			}, () => {
				this.title = environment.siteTitle;
				this.icon = "";
				this.metaSetter.setMeta({
					title: environment.siteTitle,
					description: environment.defaultMetaDescription,
					metaImageURL: environment.defaultMetaImage,
					canonicalURL: environment.canonicalDomain + "/news/authors",
				})
			});

		this.getAuthors();
	}

	getAuthors() {
		this.authorsLoading = true;
		this.authorsError = false;

		this.blogService.getAuthors()
			.subscribe(authors => this.postAuthorsFetch(authors),
			() => {
				this.authorsError = true;
			})
	}

	postAuthorsFetch(authors: Array<BlogAuthor>) {
		this.authors = authors;
		this.authorsLoading = false;
	}

}
